import makeTooltipContext from 'utils/dashboard/factories/tooltip/makeTooltipContext';

export const { TooltipProvider, useTooltipContext } = makeTooltipContext({
  isDashboardTooltip: false,
  id: 'appTooltip',
});
